export const RECORD_STATUS_UNSTART = 'unstart';
export const RECORD_STATUS_RECORDING = 'recording';
export const RECORD_STATUS_PAUSED = 'paused';
export const RECORD_STATUS_STOPPED = 'stopped';